/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Cta_H2Inputs */

const es_l7_cta_h2 = /** @type {(inputs: L7_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuéntanos cómo es tu barco.`)
};

const gl_l7_cta_h2 = /** @type {(inputs: L7_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cóntanos como é o teu barco.`)
};

const en_l7_cta_h2 = /** @type {(inputs: L7_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us about your boat.`)
};

/**
* | output |
* | --- |
* | "Tell us about your boat." |
*
* @param {L7_Cta_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_cta_h2 = /** @type {((inputs?: L7_Cta_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Cta_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_cta_h2(inputs)
	if (locale === "en") return en_l7_cta_h2(inputs)
	return es_l7_cta_h2(inputs)
});